module.exports = __webpack_public_path__ + "img/mylene_timeless.b6aa29bf.jpg";